import {select} from 'd3-selection';
import {NotAvailableSelectorError} from '../../modules/error';
import {className, getUniqueId} from '../../modules/util';

const background = 'none';
function appendClipPath(selection, innerSize, margin = 0, transition = null) {
  let pos = rect => {
    rect.attr('x', -margin)
      .attr('y', -margin)
      .attr('width', innerSize.width + margin*2)
      .attr('height', innerSize.height + margin*2);
  }
  let defs = selection.selectAll(function() {
      return this.childNodes;
    }).filter(function() {
      return select(this).classed(className('canvas-g-defs'))
    })
  if (defs.empty()) {
    defs = selection.append('defs')
      .attr('class', className('canvas-g-defs'))
      .datum(innerSize)  
    defs.append('clipPath')
      .attr('id', () => getUniqueId('canvas-g-'))
      .attr('class', className('canvas-g-clip-path'))
    .append('rect')
      .attr('class', className('canvas-g-clip-path-rect'))
      .call(pos);
  }
  
  let rect = defs.select(className('canvas-g-clip-path-rect', true));
  if (transition) rect = rect.transition().duration(transition.duration).delay(transition.delay);
  rect.call(pos);
}
function renderCanvas (margin = 0) {
  let selector = this.container();
  if(selector === null) return null;
  let offset = this.offset();
  let innserSize= this.innerSize();
  let markLocal = this.__execs__.mark;
  if(typeof selector !== 'string') {
    selector = select(selector);
    if (selector.empty()) throw new NotAvailableSelectorError();
    if (selector.node().tagName === 'g' || selector.node().tagName === 'G') {
      if (selector.select(className('canvas-g', true)).empty() ) {
        this.__execs__.canvas = selector.append('g').attr('class', className('canvas-g'));
        this.__execs__.canvas.append('g').attr('class', className('regions'));
      } else if(!this.__execs__.canvas) {
        this.__execs__.canvas = selector.select(className('canvas-g', true));
      }
      markLocal.set(this.__execs__.canvas.node(), {x:offset.left, y:offset.right}); //해당 G는 일종의 마크라 생각하고 이동 위치 저장한다.
      this.__execs__.canvas
        .attr('transform', 'translate(' + [offset.left, offset.right] +')');
    }
    this.__execs__.canvas.datum(this.__execs__.munged); //데이터 추가
    this.__execs__.canvas.call(appendClipPath, innserSize, margin, this.transition());
    return ;  
  }

  let svg;
  if (this.__execs__.canvas) { //canvas 있는 경우 svg만 찾기
    svg = select(this.__execs__.canvas.node().parentNode);
  } else { //canvas 없는 경우는 svg 및 g 추가;
    let container = select(selector);
    if (container.empty()) {
      throw new NotAvailableSelectorError();
    }
    svg = container.select(className('frame', true)).select('svg');
    
    this.__execs__.canvas = svg.append('g').attr('class', className('canvas-g'))
      .attr('transform', 'translate(' + [offset.left, offset.top] +')');
    this.__execs__.canvas.append('rect')
      .attr('class', className('background'))
      .style('fill', background);
    this.__execs__.canvas.append('g').attr('class', className('regions'));
  }
  let trans = this.transition();
  this.__execs__.canvas.transition().duration(trans.duration).delay(trans.delay)
    .attr('transform', 'translate(' + [offset.left, offset.top] +')');
  this.__execs__.canvas.attr('width', innserSize.width).attr('height', innserSize.height);
  this.__execs__.canvas.select(className('background', true))
    .attr('width', innserSize.width).attr('height', innserSize.height);
  this.__execs__.canvas.datum(this.__execs__.munged); //데이터 추가
  this.__execs__.canvas.call(appendClipPath, innserSize, margin, this.transition());
  return this;
}

export default renderCanvas;


// WEBPACK FOOTER //
// ./layouts/default/renderCanvas.js